// extracted by mini-css-extract-plugin
module.exports = {"container":"B_ExpandExample_container_aaGbX"};